// Vendor libs
import * as Cookie from 'app/packages/cookie-utils';

// Module dependencies
import user from 'app/common/lib/User';

/**
 * @type {string}
 * @const
 */
const GO_CONVERSION_PIXEL = '983308403';

/**
 * @type {string}
 * @const
 */
const GO_CONVERSION_LABEL = 'BAZXCN218AYQ87Dw1AM';

/**
 * Create image from url with cache busting.
 *
 * @private
 * @param {string} url image url
 */
const pingUrl = function(url) {
  const i = new Image();

  // Append a cache buster to the URL.
  // TODO: Make this handle the case where "url" doesn't already have a query string.
  url += '&cache_bust=' + Date.now();
  i.src = url;
};

const AdTracking = {};

/**
 * Load Facebook and Google tracking pixels.
 */
AdTracking.trackConversions = function() {
  if (!user.isAuthenticated()) {
    return;
  }
  if (Cookie.get(PCONST.COOKIE_USER_JUST_REGISTERED)) {
    // Track new user conversions.
    AdTracking.pingGoogleConversion(GO_CONVERSION_PIXEL, GO_CONVERSION_LABEL);
    AdTracking.pingFacebookConversion();
    Cookie.unset(PCONST.COOKIE_USER_JUST_REGISTERED);
  }
};

AdTracking.pingGoogleConversion = function(id, label) {
  pingUrl(
    'https://www.googleadservices.com/pagead/conversion/' +
      id +
      '/?value=0&label=' +
      label +
      '&guid=ON&script=0',
  );
};

AdTracking.pingFacebookConversion = function() {
  pingUrl('https://www.facebook.com/offsite_event.php?id=6016714330942&value=0&currency=USD');
};

export default AdTracking;
